module.exports = __webpack_public_path__ + "img/logo.f79a20b7.svg";